"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEventToData = void 0;
const mapEventToData = detail => ({
  atpClusterId: detail.atpClusterId,
  droppingId: detail.replaceSubscription?.droppingId,
  initialProductCode: detail.initialProductCode,
  lineNumber: detail.lineNumber,
  mode: detail.mode,
  originalItemCode: detail.originalItemCode,
  originalQuantity: detail.originalQuantity,
  placement: detail.placement,
  position: detail.position,
  productCodes: detail.productCodes,
  subscriptionId: detail.replaceSubscription?.subscriptionId
});
exports.mapEventToData = mapEventToData;